<template>
  <div class="pt-2 field tree-select-field" :style="field.style" v-if="condition">
    <div class="tree-select-head">
      <label class="label tree-select-label">
        <span>
          {{ local_value.label }}
          {{ local_value.required ? " *" : "" }}
        </span>
        <a class="tree-select-undo" href="" @click.prevent="undoSelected()" title="Hiq te selektuarin">
          <i class="fa-sharp fa-solid fa-arrow-rotate-left"></i>
        </a>
      </label>
      <div class="tree-select-filter" v-if="expand">
        <input type="text" placeholder="Kërko..." class="input is-small" v-model="search" />
        <a class="tree-select-close" href="" @click.prevent="resetValue()" title="Mbyll listen">Mbyll</a>
      </div>
    </div>
    <a v-if="!expand" class="tree-select-trigger" href="" @click.prevent="resetValue()">
      <ul v-if="local_value.selected_options">
        <li v-for="so in Object.keys(local_value?.selected_options)?.filter((k) => local_value.selected_options[k])" :key="so">
          <i class="mr-1 text-green-700 fa fa-check"></i>
          <span class="text-green-800 is-uppercase">
            {{ local_value.selected_options[so] }}
          </span>
        </li>
        <li v-if="Object.keys(local_value.selected_options)?.length == 0" class="tree-select-placeholder">Zgjidhni...</li>
      </ul>
    </a>
    <div
      class="control tree-select-dropdown"
      :style="{ maxHeight: dropdownMaxHeight }"
      v-if="expand"
      :class="[local_value.left_icon ? 'has-icons-left' : '', local_value.right_icon ? 'has-icons-right' : '']"
    >
      <div class="tree-select-list">
        <div v-if="local_value?.is_multiple == 1" class="tree-select-all">
          <label class="checkbox">
            <input type="checkbox" :checked="allSelected" @change="toggleSelectAll" />
            Zgjidhni të gjitha
          </label>
        </div>
        <div v-for="(parent, idx) in local_value.options.filter((a) => JSON.stringify(a).toLowerCase().includes(search.toLowerCase()))" :key="parent.id">
          <div
            :class="{
              'has-border-bottom': idx != local_value?.options?.length - 1,
            }"
            class="is-block is-flex is-align-items-center"
          >
            <a v-if="!parent.children || field?.select_root || local_value?.is_standalone_multiple == 1" class="mr-1" @click.prevent="setSelected(parent)">
              <i class="mr-1 fa" :class="[local_value.selected_options[parent.id] ? 'fa-square-check' : 'fa-square has-text-grey-light']"></i>
              <i
                class="mr-1 fa fa-rectangle"
                :style="{
                  background: field.isColor == true ? parent.name : '',
                  height: field.isColor == true ? '18px' : '',
                  width: field.isColor == true ? '70%' : '',
                }"
                :class="field.isColor == true ? 'mt-2' : ''"
              ></i>
            </a>
            <div v-else style="width: 20px; height: 13px; display: inline-block">&nbsp;</div>

            <a href="" @click.prevent="collapse(parent)" class="tree-select-row-label is-flex is-align-items-center is-flex-grow-1">
              <span class="tree-select-row-text" :class="{ 'has-text-success-dark': Object.keys(local_value.selected_options).includes(parent.id) }">
                {{ field.isColor === true ? "" : parent.label }}
              </span>
              <i
                class="fa tree-select-caret"
                :class="{
                  'fa-caret-down': !parent.expand,
                  'fa-caret-up': parent.expand,
                }"
                v-if="parent.children"
              ></i>
            </a>

            <label class="ml-auto mr-5 checkbox" v-if="parent.children && parent.children.length > 0 && local_value?.is_multiple == 1">
              <input type="checkbox" :checked="areAllChildrenSelected(parent)" @change="toggleChildren(parent)" />
            </label>
          </div>
          <div v-if="parent.expand && parent.children">
            <tree-options
              :root_value="local_value.root_value"
              :i="1"
              :selected_options="local_value.selected_options"
              :inherited_selected_options="local_value.inherited_selected_options"
              :field="field"
              :main_local_value="local_value"
              :options="parent.children"
              @toggle-option="handleToggleOption"
              @toggle-children="toggleChildren"
            ></tree-options>
          </div>
        </div>
      </div>
    </div>
    <p class="help is-danger" v-if="local_value.unique !== undefined">
      <span v-if="local_value.exists == 1"> {{ local_value.label }} vendosur eshte i zene! </span>
    </p>
    <p class="help is-danger" v-if="false && local_value.required && !local_value.selected_options && (!local_value.value || local_value == '')">
      {{ local_value.required_text ? local_value.required_text : "E detyrueshme" }}
    </p>
    <p class="help is-danger" v-if="false && local_value.required && Object.keys(local_value.selected_options)?.length == 0">
      {{ local_value.required_text ? local_value.required_text : "E detyrueshme" }}
    </p>

    <ul v-if="local_value.inherited_selected_options?.length > 0" class="mb-3 border border-gray-200">
      <li class="p-1 font-thin border border-gray-300">Te trashguara</li>
      <li v-for="sel_option in local_value.inherited_selected_options" class="ml-1" :key="sel_option.id">
        <i class="mr-2 text-green-500 fa fa-check"></i>
        <span class="font-light text-indigo-800"> {{ sel_option.roots.split(" > ").length > 1 ? sel_option.roots.split(" > ").slice(1).reverse().join(" > ") : sel_option.roots }}: </span>

        {{ sel_option.attribute_name ? sel_option.attribute_name : "" }}
        {{ sel_option.accessory_name ? sel_option.accessory_name : "" }}
      </li>
    </ul>
  </div>
</template>

<script>
// (The script section remains exactly the same as before)
import treeOptions from "./components/tree-option.vue";
import { ref, provide, reactive } from "vue";
export default {
  components: {
    treeOptions,
  },
  props: ["field", "fields"],
  setup() {
    const selectedvalue = ref({});
    const local_value = reactive({});
    provide("selectedvalue", selectedvalue);
    return {
      selectedvalue,
      local_value,
    };
  },
  data() {
    return {
      expand: false,
      label: "",
      search: "",
    };
  },

  methods: {
    // Helper function to recursively get all descendant IDs
    getAllDescendantIds(node, ids = []) {
      if (node.children) {
        node.children.forEach((child) => {
          ids.push(child.id);
          this.getAllDescendantIds(child, ids);
        });
      }
      return ids;
    },

    collapse(p) {
      if (!p.children) {
        this.setSelected(p);
        return;
      }
      this.local_value = {
        ...this.local_value,
        options: [
          ...this.local_value.options.map((e) => {
            if (e.id == p.id) e.expand = !e.expand;
            return e;
          }),
        ],
      };
    },
    resetValue() {
      this.expand = !this.expand;
    },
    undoSelected() {
      this.local_value.selected_options = {};
      this.$toast.success("Te gjitha opsionet e selektuara jane fshire!");
      this.$emit("syncField", this.local_value);
    },
    setSelected(f) {
      var tmp = this.local_value;
      if (this.local_value.mode == "multiple") {
        if (!tmp.selected_options) tmp.selected_options = {};

        if (tmp.selected_options[f.id]) delete tmp.selected_options[f.id];
        else tmp.selected_options[f.id] = f.label;
        this.local_value = { ...tmp };
      } else {
        // If mode is not multiple, only one can be selected
        tmp.selected_options = {};
        tmp.selected_options[f.id] = f.label;
        this.local_value = { ...tmp };
      }
      this.$emit("syncField", this.local_value);
    },
    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      let newSelectedOptions = {};

      if (isChecked) {
        // Select all visible options and their children recursively
        this.local_value.options
          .filter((a) => JSON.stringify(a).toLowerCase().includes(this.search.toLowerCase()))
          .forEach((option) => {
            newSelectedOptions[option.id] = option.label; // Select the parent itself
            this.selectAllChildrenAndSelfRecursive(option, newSelectedOptions); // Select all its descendants
          });
      }
      this.local_value.selected_options = { ...newSelectedOptions };
      this.$emit("syncField", this.local_value);
    },

    // Recursive helper to select option and its children
    selectAllChildrenAndSelfRecursive(node, selectedOptionsObj) {
      if (node.children) {
        node.children.forEach((child) => {
          selectedOptionsObj[child.id] = child.label;
          this.selectAllChildrenAndSelfRecursive(child, selectedOptionsObj);
        });
      }
    },

    // Method to check if all children (and their descendants) of a parent are selected
    areAllChildrenSelected(parent) {
      if (!parent.children || parent.children.length === 0) {
        return false; // No children to select
      }

      // Collect all descendant IDs including the parent itself
      const descendantIds = [parent.id];
      this.getAllDescendantIds(parent, descendantIds);

      // Check if all collected descendant IDs are in selected_options
      return descendantIds.every((id) => this.local_value.selected_options && this.local_value.selected_options[id]);
    },

    // Method to toggle selection of all children (and their descendants) for a specific parent
    toggleChildren(parent) {
      const allCurrentlySelected = this.areAllChildrenSelected(parent);
      let newSelectedOptions = { ...this.local_value.selected_options };

      const toggleDescendants = (node, select) => {
        if (select) {
          newSelectedOptions[node.id] = node.label;
        } else {
          delete newSelectedOptions[node.id];
        }
        if (node.children) {
          node.children.forEach((child) => toggleDescendants(child, select));
        }
      };

      // Toggle the parent itself and all its descendants
      toggleDescendants(parent, !allCurrentlySelected);

      this.local_value.selected_options = { ...newSelectedOptions };
      this.$emit("syncField", this.local_value);
    },

    handleToggleOption(optionToToggle) {
      console.log("Option toggled from child component:", optionToToggle);
      this.setSelected(optionToToggle);
    },
  },
  computed: {
    dropdownMaxHeight() {
      return this.local_value.max_height || this.field?.max_height || "360px";
    },
    condition() {
      var is_visible = true;
      if (this.local_value.vif) {
        if (this.fields)
          this.fields.map((f) => {
            if (f.length) {
              f.map((ff) => {
                this.local_value.vif.map((c) => {
                  if (ff.name == c.field) {
                    if (c.value_not !== undefined) is_visible = ff.value != c.value_not;
                  }
                });
              });
            } else {
              this.local_value.vif.map((c) => {
                if (f.name == c.field) {
                  if (c.value_not !== undefined) {
                    is_visible = f.value != c.value_not;
                  }
                  if (c.value !== undefined) {
                    is_visible = f.value == c.value;
                  }
                }
              });
            }
          });
      }
      return is_visible;
    },
    allSelected() {
      const filteredOptions = this.local_value.options.filter((a) => JSON.stringify(a).toLowerCase().includes(this.search.toLowerCase()));
      if (filteredOptions.length === 0) {
        return false;
      }

      // Check if all filtered options AND their descendants are selected
      return filteredOptions.every((option) => {
        const descendantIds = [option.id]; // Include parent itself
        this.getAllDescendantIds(option, descendantIds);
        return descendantIds.every((id) => this.local_value.selected_options && this.local_value.selected_options[id]);
      });
    },
  },
  watch: {
    field: {
      handler: function (val) {
        this.local_value = { ...val };
      },
      deep: true,
    },
    selectedvalue() {
      if (this.selectedvalue != "") {
        this.setSelected({ ...this.selectedvalue });
        this.selectedvalue = "";
      }
    },
  },
  created() {
    this.local_value = { ...this.field };
  },
};
</script>

<style scoped>
.label {
  margin-bottom: 0 !important;
  color: grey;
}

.tree-select-head {
  margin-bottom: 6px;
}
.tree-select-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tree-select-undo {
  color: #64748b;
}
.tree-select-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.tree-select-filter .input {
  flex: 1 1 auto;
  min-width: 0;
}
.tree-select-close {
  flex: 0 0 auto;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
}
.tree-select-close:hover {
  background: #fef2f2;
}
.tree-select-trigger {
  display: block;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  min-height: 40px;
  background: #fff;
}
.tree-select-placeholder {
  margin-left: 2px;
  font-style: italic;
  color: #94a3b8;
}
.tree-select-list {
  padding: 4px 0;
}
.tree-select-all {
  display: flex;
  justify-content: flex-end;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
}
.tree-select-list > div > .is-flex.is-align-items-center:hover {
  background: #f8fafc;
}
.tree-select-row-label {
  min-width: 0;
  padding: 8px 4px;
}
.tree-select-row-text {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.35;
}
.tree-select-caret {
  flex: 0 0 auto;
  margin-left: 8px;
  color: #64748b;
}

.has-border {
  box-shadow: inset 0 0.0625em 0.125em hwb(0deg 4% 96% / 5%);
  border: solid 1px #dbdbdb;
}

.has-border-bottom {
  border-bottom: 1px solid #dbdbdb;
}

.tree-select-dropdown {
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 #f1f5f9;
}

.tree-select-dropdown::-webkit-scrollbar {
  width: 10px;
}

.tree-select-dropdown::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 8px;
}

.tree-select-dropdown::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 8px;
  border: 2px solid #f1f5f9;
}

.tree-select-dropdown::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}
</style>
